import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../services/base/base.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(public baseService: BaseService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.endsWith('ForwardPaginateActivity') || request.url.endsWith('PaginateActivity'))
      return next.handle(request);

    this.baseService.blockStart();
    return next.handle(request).pipe(
      finalize(() => {
        this.baseService.blockStop();
      })
    );
  }
}
